import { retrieveSchema as retrieveSchemaUtil } from '@rjsf/utils';
import { customizeValidator } from '@rjsf/validator-ajv6';
import { memoize } from 'lodash';

// file fields keep format data-url because MDMS discovers them by it, but the widget
// uploads eagerly and submits an S3 URL, so the format must accept both shapes
const validator = customizeValidator({
  customFormats: {
    'data-url': /^(?:data:([a-z]+\/[a-z0-9-+.]+)?;(?:name=(.*);)?base64,(.*)|https:\/\/\S+)$/,
  },
});

const resolver = (schema, formData) => JSON.stringify({ schema, formData });

function retrieveSchema(schema, formData) {
  if (!schema || typeof schema !== 'object') return null;
  let defaultedFormData = formData;
  if (!formData || typeof formData !== 'object') {
    defaultedFormData = {};
  }

  const rootSchema = schema;
  return retrieveSchemaUtil(validator, schema, rootSchema, defaultedFormData);
}
const retrieveSchemaMemo = memoize(retrieveSchema, resolver);

export { validator, retrieveSchemaMemo as retrieveSchema };
